<template>
  <v-dialog
    v-model="dialog"
    width="800"
    :fullscreen="$vuetify.breakpoint.mobile"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="header && $vuetify.breakpoint.mobile"
        color="primary"
        fab
        fixed
        bottom
        right
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>

      <v-btn
        depressed
        v-else
        :small="!header"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        Nueva búsqueda
      </v-btn>
    </template>

    <v-card color="background">
      <v-card-title>
        Crear búsqueda
        <v-spacer></v-spacer>

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0 px-0">
        <search @save="save"></search>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreateSearch } from "@/graphql/mutations/searches";
import Search from "@/components/shared/Search";

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    header: {
      type: Boolean,
      required: false,
      default: false
    },
    inquiryId: {
      type: String | Number,
      required: false,
      default: null
    },
    userId: {
      type: String | Number,
      required: false,
      default: null
    }
  },

  methods: {
    save(search) {
      this.$apollo
        .mutate({
          mutation: CreateSearch,
          variables: {
            input: {
              attributes: search,
              inquiryId: this.inquiryId,
              userId: this.userId || this.$route.params.id
            }
          }
        })
        .then(res => {
          this.$emit("reload");
          this.dialog = false;
        });
    }
  },

  components: { Search }
};
</script>
